<!--<router-outlet></router-outlet>-->
<div class="mes-terminal-wrap" [ngClass]="{ error: currentErrorCode }" @inOutAnimation>
	@if (employeeData$ | async; as theData) {
		<div id="employee-select-task" class="mes-terminal-page">
			<div class="mes-terminal-header">
				<h1>{{ 'mes.mes-production-terminal.choose-worktask.header' | translate }}</h1>
				@if (offWorkTask$ | async; as offWorkTask) {
					<div class="qr">
						<div class="qr-title"></div>
						<app-mes-qr-component [workTaskKey]="'ACS_W_' + offWorkTask[0].alias" [workTaskId]="" [size]="140" (click)="taskClicked(offWorkTask[0], theData[0])"></app-mes-qr-component>
					</div>
				}
			</div>
			<div class="mes-terminal-content pb-0">
				<div class="tasks-wrap">
					<div class="tasks-all-wrap">
						<div class="explain mb-16">
							{{ 'mes.mes-production-terminal.choose-worktask.full-list-label' | translate }}
						</div>
						@if (workTasks$ | async; as workTasks) {
							<div class="all-tasks-list">
								@for (workTask of workTasks; track workTask) {
									<div class="clickable-task task machine" (click)="taskClicked(workTask, theData[0])">({{ workTask.alias }}) {{ workTask.name }}</div>
								}
							</div>
						}
					</div>
					<div class="tasks-faves-wrap">
						<div class="explain mb-16">
							{{ 'mes.mes-production-terminal.choose-worktask.fav-list-label' | translate }}
						</div>
						@if (theData[2].length) {
							<div class="qr-flexgrid">
								@for (qrwc of theData[2]; track qrwc) {
									<div class="qr clickable-task">
										<app-mes-qr-component [workTaskKey]="'ACS_W_' + qrwc.alias" [workTaskId]="" (click)="taskClicked(qrwc, theData[0])"></app-mes-qr-component>
										<div class="qr-title">{{ qrwc.name }}</div>
									</div>
								}
							</div>
						} @else {
							<div class="explain" style="font-size: 16px">Der er ikke registreret nogen opgaver på din brugerprofil endnu. Vælg en opgave i listen til venstre.</div>
						}
					</div>
				</div>
			</div>
			<footer class="mes-terminal-footer">
				<h3>
					{{ 'mes.mes-production-terminal.choose-worktask.current-worktask.name-text' | translate }}
					<span class="lightyellow">{{ theData[0].firstName }} {{ theData[0].lastName }} ({{ 'mes.mes-production-terminal.choose-worktask.current-worktask.employeekey-text' | translate }} {{ theData[0].alias }})</span>
					.
					@if (theData[1].alias !== 'Off') {
						{{ 'mes.mes-production-terminal.choose-worktask.current-worktask.current-task-pretext' | translate }}
						<span class="lightyellow" id="checkedInTask">{{ theData[1].name }}</span>
						.
						<!-- siden kl. <span class="lightyellow" id="checkedInTime">hh:mm</span>-->
					} @else {
						{{ 'mes.mes-production-terminal.choose-worktask.current-worktask.no-task' | translate }}.
					}
				</h3>
				<button id="change-employee-number" class="mes-terminal-button" (click)="resetEmployeeNumber()">
					<div class="icon">
						<img src="./assets/mes/terminal/arrow--left.svg" />
					</div>
					<div (click)="resetEmployeeNumber()">
						{{ 'mes.mes-production-terminal.choose-worktask.change-employee' | translate }}
					</div>
				</button>
			</footer>
		</div>
	} @else {
		<div id="employee-register" class="mes-terminal-page">
			<div class="mes-terminal-header">
				<h1>{{ 'mes.mes-production-terminal.employeekey-enter.header' | translate }}</h1>
			</div>
			<div class="mes-terminal-content">
				<div class="explain mt-100 mb-16">
					{{ 'mes.mes-production-terminal.employeekey-enter.label' | translate }}
				</div>
				<form #form>
					<div class="employee-number-fields">
						<input type="text" class="employee-number" placeholder="" id="employee-number" spellcheck="false" (blur)="keepFocused()" #employeeNumberInputField [disabled]="loadingEmployee" autocomplete="off" />
						<button href="#" id="next" class="mes-terminal-button icon-right" type="submit" #submitButton>
							<div class="icon">
								<img src="./assets/mes/terminal/arrow--right.svg" />
							</div>
							<div>
								{{ 'mes.mes-production-terminal.employeekey-enter.nxt-btn' | translate }}
							</div>
							@if (loadingEmployee) {
								<div class="spinner"></div>
							}
						</button>
						@if (errorCodes[currentErrorCode]; as err) {
							<div [class]="err['cssClass'] + ' msg'">{{ err.text }}</div>
						}
						@if (currentErrorDetails) {
							<div class="mes-check-in-error-details">
								{{ currentErrorDetails | json }}
							</div>
						}
					</div>
				</form>
				@if (userSelectedTask$ | async; as userSelectedTask) {
					<div class="user-selected-task">
						@if (userSelectedTask.task.alias != 'Off') {
							<span>
								<span class="lightyellow">
									{{ userSelectedTask.employee.firstName }}
									{{ userSelectedTask.employee.lastName }} (lønnr. {{ userSelectedTask.employee.alias }})
								</span>
								checkede ind på
								<span class="lightyellow">{{ userSelectedTask.task.name }}</span>
								lige nu.
								<div class="progress"></div>
							</span>
						}
						@if (userSelectedTask.task.alias == 'Off') {
							<span>
								<span class="lightyellow">
									{{ userSelectedTask.employee.firstName }}
									{{ userSelectedTask.employee.lastName }} (lønnr. {{ userSelectedTask.employee.alias }})
								</span>
								checkede ud
								<div class="progress"></div>
							</span>
						}
					</div>
				}
			</div>
			<footer class="mes-terminal-footer-first">AciesMES v1.0</footer>
		</div>
	}
</div>
@if (showLoadingOverlay) {
	<div class="mes-loading-overlay">
		<div class="spinner"></div>
	</div>
}
